import { Link } from 'react-router-dom'

// AI-CONTEXT: See docs/features/deep-analysis-period.md
// The title of an Analyse card. With a `titleLink` it also opens the deep
// analysis: the 'Diepte-analyse' icon only has a name on hover (testronde
// 2026-10-28, B5). A link inside the heading, never the heading inside a
// button. AI-CONTEXT: See docs/pitfalls.md#ui-heading-inside-button-stops-being-a-heading

/**
 * @param {object} props
 * @param {string} props.title - The card title (activity, effect or research name)
 * @param {string} [props.titleLink] - Path to the deep analysis; without it the title is plain text
 */
const AnalysisCardTitle = ({ title, titleLink }) => (
    <h3 className='analysis-card-title'>
        {titleLink
            ? <Link to={titleLink} className='analysis-card-title-link'>{title}</Link>
            : title}
    </h3>
)

export default AnalysisCardTitle
